import Seo from '../Seo'

const BOOK_DEMO_URL = 'https://benjaminintelligence.com/book-demo'
const HOME_URL = 'https://benjaminintelligence.com'

const BenjaminThankYouPage = () => {
  return (
    <section className='relative flex min-h-screen flex-col overflow-hidden bg-[#050913] pt-20 text-white'>
      <Seo
        title='Benjamin sales pipeline updated'
        description='The legacy Benjamin launch brief has been retired. Continue on the Benjamin website.'
        path='/benjamin-thank-you'
        noindex
      />

      <div className='absolute inset-0 -z-10'>
        <div className='absolute inset-0 bg-gradient-to-b from-[#050913] via-[#080f1f] to-[#050913]' />
        <div
          className='absolute -top-32 left-1/2 h-[560px] w-[560px] -translate-x-1/2 rounded-full opacity-30'
          style={{
            background:
              'radial-gradient(50% 50% at 50% 50%, rgba(248,129,22,0.35) 0%, rgba(248,129,22,0) 65%)',
            filter: 'blur(60px)'
          }}
        />
      </div>

      <div className='mx-auto flex w-full max-w-4xl flex-1 flex-col gap-8 px-6 py-16'>
        <div className='rounded-3xl border border-white/10 bg-white/5 p-8 shadow-[0_35px_90px_rgba(0,0,0,0.45)]'>
          <p className='text-xs uppercase tracking-[0.35em] text-pyramid-1'>
            Benjamin
          </p>
          <h1 className='mt-3 text-3xl font-black md:text-4xl'>
            The legacy launch brief has been retired
          </h1>
          <p className='mt-4 text-lg text-slate-200'>
            Benjamin now uses direct website forms that feed the internal CRM
            pipeline. This page is kept only as a safe landing for older links.
          </p>
          <p className='mt-6 text-sm text-slate-300'>
            If you want to continue, book a demo on the main Benjamin website
            or return to the new product homepage.
          </p>

          <div className='mt-8 flex flex-wrap items-center gap-4'>
            <a
              href={BOOK_DEMO_URL}
              className='rounded-full bg-gradient-to-r from-pyramid-1 via-pyramid-10 to-pyramid-19 px-6 py-3 text-sm font-bold text-ebony shadow-lg shadow-pyramid-10/40'
            >
              Book a demo
            </a>
            <a
              href={HOME_URL}
              className='rounded-full border border-white/30 px-6 py-3 text-sm font-semibold text-white/90'
            >
              Go to Benjamin
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default BenjaminThankYouPage
